import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-induction-program',
  templateUrl: './induction-program.component.html',
  styleUrls: ['./induction-program.component.scss']
})
export class InductionProgramComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
